import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Химия. 9 класс",
        subject: "Химическое загрязнение атмосферы, природных вод и почвы",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Химическое загрязнение атмосферы, природных вод и почвы",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Заграничная Надежда Анатольевна",
                grade: "кандидат педагогических наук, старший научный сотрудник лаборатории профильного образования ФГБНУ «ИСРО»",
                subGrade: "",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: `<div style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>
                                <p>В состав курсов химии базового и углубленного уровней, согласно ФГОС ООО (2022 г), введён раздел «Химия и окружающая среда», в котором обновлено содержание обучения. Существует необходимость методической поддержки работы учителей в направлении экологического воспитания и обучения школьников, а также формирования естественно-научной грамотности выпускников основной школы при изучении данного заключительного раздела в 9 классе.</p>
                                </div>
                                <div style='padding: 2.4rem;'>
                                <p>В ФОП ООО тема урока «Химическое загрязнение атмосферы, природных вод и почвы» изучается в рамках раздела как на базовом, так и на углубленном уровне. Содержание урока способствует обобщению ранее изученного материала экологической направленности. В то же время, отбор современных и актуальных примеров и ситуаций для раскрытия содержания урока, приближение учебного материала к жизненным интересам подростков – ещё не решенные задачи. Это может вызывать затруднения в работе учителя химии. </p>
                                </div>
                                <div style='padding: 2.4rem;'>
                                <p>Материалы данного кейса будут полезны учителю-предметнику как в определении содержания обучения на уроке, так и при организации учебно-познавательной деятельности обучающихся в урочной и внеурочной работе. Самостоятельная деятельность, организованная учителем в рамках урока, способствует развитию у школьников умений использовать химические знания в повседневной жизни для обеспечения безопасности и сохранения как своего здоровья, так и здоровья окружающей среды.</p>
                                </div>
                                <div style='padding: 2.4rem;'>
                                <p>
                                В составе материалов кейса:
                                </p>
                                <ul>
                                <li>приведены актуальные примеры загрязнения атмосферы, воды и почвы, обобщающие фактологический материал, с которым ученики познакомились при изучении химии в 8-9 классах; </li>
                                <li>сделан акцент на использование приёмов межпредметной интеграции для более полного раскрытия содержания урока;</li>
                                <li>предложены варианты организации учебно-познавательной деятельности обучающихся в зависимости от уровня подготовки, приёмы обобщения и закрепления знаний;</li>
                                <li>включён дидактический материал (задания разной сложности) для учеников, который учитель может использовать как на уроке, так и для организации домашней работы;</li>
                                <li>приведён текст статьи, в которой рассмотрены методические приёмы достижения результатов обучения по теме урока.</li>
                                </ul>
                                </div>
                                <div style='padding: 2.4rem; padding-top: 0'>
                                <p>Учебный материал урока служит основой для достижения таких результатов, как формирование естественно-научного мировоззрения и повышение уровня экологической культуры, понимание значения химической науки и технологии в жизни современного общества, развитие познавательной мотивации и интереса к обучению.</p>
                                </div>

                                `
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4",
            contentBefore: [{
                type: "text",
                text: `
                    <p style="text-indent: 2vw;">Раздел «Химия и окружающая среда» завершает изучение неорганической химии в 9 классе. Поэтому на заключительных уроках научный уровень обучения, степень обобщения учебного материала должны быть выше, чем при предварительном ознакомлении с экологическими ситуациями в 8 и 9 классах. </p>
                    <p style="text-indent: 2vw;">Содержание данного урока имеет интегративный характер, а значит, изучение материала должно быть построено как на внутрипредметной интеграции знаний, так и на межпредметной основе.</p>
                    <p style="text-indent: 2vw;">Тема урока раскрывается в соответствии с планом:
                    <ol>
                    <li>Химическое загрязнение окружающей среды. В чём его опасность? (Актуализация проблемы урока).</li>
                    <li>Какие вещества являются химическими загрязнителями? Как измеряют их содержание в природе? (Основные понятия. Формулирование гипотезы).</li>
                    <li>Откуда появляются химические загрязнители в воздухе, в воде и почве? (Обоснование гипотезы).</li>
                    <li>Как бороться с загрязнением окружающей среды? Принципы «зелёной химии» (Следствия из гипотезы).</li>
                    <li>Выводы. </li>
                    </ol>
                    </p>
                    <p style="text-indent: 2vw;">В рамках урока целесообразно обращаться к примерам, раскрывающим экологическую ситуацию в России. </p>
                    <p style="text-indent: 2vw;">Рассмотрение каждой проблемной ситуации должно завершаться обсуждением возможности снижения негативного воздействия на окружающую среду. Необходимо познакомить школьников с работой правительства РФ, направленной на охрану окружающей среды. В качестве примера может быть представлен Федеральный проект «Чистый воздух». </p>
                    <p style="text-align: center"><img src="images/chem_cont.png"></p>
                    <p style="text-indent: 2vw;">Рассмотрим, как может быть реализовано учебное содержание на каждом из этапов урока.</p>
                
                `
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1012",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Федеральный государственный образовательный стандарт основного общего образования. Приложение к приказу Министерства просвещения Российской Федерации от 21 мая 2021 года №287. URL: https://fgos.ru/fgos/fgos-ooo/  (Дата обращения: 04.03.2023)",
                "Федеральная образовательная программа основного общего образования  . URL:https://edsoo.ru/Federalnaya_obrazovatelnaya_programma_srednego_obschego_obrazovaniya.htm (Дата обращения: 14.02.2023)",
                "Заграничная Н.А. Профессиональное саморазвитие учителя химии. Воспитательный потенциал курса химии как основа формирования личностных результатов обучения. 8–11 классы. Серия «Методическая лаборатория». – Волгоград: Учитель. – 2015",
                "Заграничная Н.А., Паршутина Л.А. Интеграция содержания и методов преподавания естественно-научных предметов в школьном образовании / Н.А. Заграничная, Л.А. Паршутина // Педагогика. 2018, №9",
                "Заграничная Н.А., Паршутина Л.А. Функциональная грамотность учащихся: условия и пути формирования// Химия в школе. 2020. №7",
                "Ковалёва Г.С., Пентин А.Ю., Заграничная Н.А. и др. Естественно-научная грамотность: сборник эталонных заданий. Выпуск 2: учебное пособие для общеобразовательных организаций / [Г.С. Ковалёва, А.Ю. Пентин, Е.А. Заграничная Н.А. и др.]; под ред. Г.С. Ковалёвой, А.Ю. Пентина. – Москва; Санкт-Петербург: Просвещение, 2021. – 143с.: ил. — (Функциональная грамотность. Учимся для жизни)",
                "Савинкина Е.В., Логинова Г.П. Химия. Для школ и классов гуманитарного профиля: Учебник. 10 класс. – Москва: АСТ-ПРЕСС, 2001",
                "Единое содержание общего образования (edsoo.ru)",
                "Сайт ИСРО. Режим достyпа: https://skiv.instrao.ru",
                "Российская электронная школа (resh.edu.ru)"
            ],
            sites: [
            ],
            filesToDownload: [
                {
                    link: "./files/additional1.pdf",
                    fileName: "Интерактивные задания"
                },
                {
                    link: "./files/additional2.pdf",
                    fileName: "Методическая статья"
                },
                {
                    link: "./files/additional3.pdf",
                    fileName: "Текстовые задания"
                }
            ]
        }
    ],
};
